import React from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { CssBaseline, Toolbar } from '@material-ui/core';

import { MenuDrawer } from './MenuDrawer';

import { fetchClientMenu, fetchMainMenu } from 'services/dynamicjson';
import { Redirect } from 'react-router-dom';
import { subscribe, unsubscribe } from 'services/chat';
import RightMenuDrawer from './RightMenuDrawer';

import { PreviewSidebar } from '../DynamicScreen/index';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
  },
  content: {
    flexGrow: 1,
    overflow: 'visible',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default function MainScreen({
  children,
  toolBarComponent,
  sidebarData,
  setSidebarData,
  rightSideBar,
  refreshScreenHandler,
}) {
  const classes = useStyles();
  const [menuLinks, setMenuLinks] = React.useState();
  const [refreshAt, setRefreshAt] = React.useState();
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (localStorage.getItem('client')) {
      fetchClientMenu().then(setMenuLinks).catch(setError);
    } else {
      fetchMainMenu().then(setMenuLinks).catch(setError);
    }
  }, [refreshAt]);

  const refresh = React.useCallback(() => setRefreshAt(moment.now()), []);
  React.useEffect(() => {
    subscribe('unread-count-change', refresh);
    return () => {
      unsubscribe('unread-count-change', refresh);
    };
  }, [refresh]);

  if (error && error.errorCode === 1001) {
    // TODO: a better solution similar to ErrorBoundary (for hooks/async)
    alert(error.userMessage);
    return <Redirect to="/logout" />;
  }
  return (
    <div className={classes.root}>
      <CssBaseline />
      <MenuDrawer
        menuLinks={menuLinks}
        toolBarComponent={toolBarComponent}
        refreshScreenHandler={refreshScreenHandler}
      />
      <main className={classes.content}>
        {!!toolBarComponent && toolBarComponent.length > 0 && <Toolbar />}
        {children}
      </main>
      {sidebarData && (
        <PreviewSidebar {...{ ...sidebarData, setSidebarData }} />
      )}
      <RightMenuDrawer
        menuComponent={rightSideBar.menuComponent}
        menuOpen={rightSideBar.menuOpen}
        setMenuOpen={rightSideBar.setMenuOpen}
        setMenuComponent={rightSideBar.setMenuComponent}
      />
    </div>
  );
}
